import { render, staticRenderFns } from "./PesquisaGrupoServicos.vue?vue&type=template&id=6f751472&scoped=true"
import script from "./PesquisaGrupoServicos.vue?vue&type=script&lang=js"
export * from "./PesquisaGrupoServicos.vue?vue&type=script&lang=js"
import style0 from "./PesquisaGrupoServicos.vue?vue&type=style&index=0&id=6f751472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f751472",
  null
  
)

export default component.exports